module.exports = __webpack_public_path__ + "static/media/one.a3b24254.jpg";